import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FloatPopupService } from 'app/services/float-popup.service';
import { WizardStepItem } from '../wizard-step-title/wizard-step-title.component';
import { MapSharedService } from 'app/services/map-shared.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { fadeInOut } from 'assets/TS/SharedAnimations';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { MainDataService, ModelMenuItemKey } from 'app/services/main-data.service';
import { ActivityService } from 'app/services/activity.service';
import { ToastrService } from 'ngx-toastr';
import { LayerService } from 'app/services/layer.service';
import { Subscription } from 'rxjs';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { GfoService } from 'app/services/gfo.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { ParityValue } from 'app/services/resolution-qc.service';
import { EditFeatureService } from 'app/services/edit-feature.service';
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { FieldMappingService, LayerCategory } from 'app/services/field-mapping.service';
import { CommonMapService } from 'app/services/common-map.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import WKT from 'ol/format/WKT';
import { AddressFishboneInfo } from 'app/services/fishbone.service';

type AddressStepProp = 'fbFilter' | 'pickAddresses' | 'pickLine';
export interface EditWizardStep extends WizardStepItem {
	prop: AddressStepProp;
}

interface FishboneFilterOption {
	key: 'fs7' | null;
	label: string;
}

@Component({
  selector: 'app-wizard-address-relocation',
  templateUrl: './wizard-address-relocation.component.html',
  styleUrls: ['../../address-manage/address-manage.component.css', './wizard-address-relocation.component.css'],
  animations: [fadeInOut]
})
export class WizardAddressRelocationComponent implements OnInit, AfterViewInit, OnDestroy {

	currentStep: EditWizardStep;

	steps: EditWizardStep[] = [
		{
			num: 1,
			label: 'Fishbone Status Filter: ',
			prop: 'fbFilter',
			isFirst: true,
			isSameLine: true
		}, 
		{
			num: 2,
			label: 'Select address points to be updated',
			prop: 'pickAddresses',
		}, {
			num: 3,
			label: 'Select a road centerline to be associated with',
			prop: 'pickLine',
			isLast: true
		}
	];
	fbFilter: FishboneFilterOption;
	fbFilters: FishboneFilterOption[] = [
		{
			key: 'fs7',
			label: 'FS7 only'
		}, {
			key: null,
			label: 'All Status'
		}
	]; 


	// relocateMode: 'sameStreet' | 'diffStreet';
	// isKeepAddressNum: boolean = true;
	// changedAddresses: any[] = []; // ids

	selectedAddresses: Feature<Point>[] = [];
	selectedLine: Feature<LineString>;

	// private selectedAddr: Feature<Point>;
	// private selectedAddrRcl: {rclGlobalId}[]; // For sameStreet mode
	// private selectedLines: Feature<LineString>[]; // For diffStreet mode
	// private originalAddrNumGeocode: {
	// 	left: number[];
	// 	right: number[]
	// };

	private linePropsById = {};

	private centerlineLayerId;
	private centerlineCate: LayerCategory;
	private addrCate: LayerCategory;

	private map: LRSMap.Map;

	// private onEditPointerdrag: (e) => any;
	// private pointerdragTimeout;
	// private pointerdragPickStreetTimeout;
	private modelKey: ModelMenuItemKey;

	private mapSub: Subscription;
	private modelSub: Subscription;

	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private editFeatureService: EditFeatureService,
		private fieldMappingService: FieldMappingService,
		private floatPopupService: FloatPopupService,
		private gfoService: GfoService,
		private layerService: LayerService,
		private cMapService: CommonMapService,
		private mainDataService: MainDataService,
		private mapSharedService: MapSharedService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private qcService: LayerQcService
	) { }

	close () {
		this.cancel();
	}
	cancel() {
		this.removeAll(true);
		this.floatPopupService.closePopup(WizardAddressRelocationComponent);
	}
	apply() {
		this.selectedAddresses.forEach((addr) => {
			const id = addr.getId();
			let attrs = this.mainDataService.getDataAttrs(id);
			if (!attrs) {
				console.log('need debug: cannot find attrs.');
				return;
			}
			// Update info related to the associated road
			let props = {};
			const line = this.selectedLine;
			const lineAttrs = this.linePropsById[line.getId()];
			const info = this.mapService.getPointSideToLine(line.getGeometry(), addr.getGeometry().getCoordinates());
			props = this.editFeatureService.carryOverCenterlineAttrsToAddress(lineAttrs, info.side, this.addrCate, this.centerlineCate, addr, true);

			Object.keys(props).forEach(key => this.mainDataService.setDataAttrs(id, key, props[key]));
			this.mainDataService.addRecToCard(id);
		});
		this.removeAll();
		this.activityService.changeTabSubject.next({
			tabKey: 'data'
		});
		this.floatPopupService.closePopup(WizardAddressRelocationComponent);
	}
	goPrev() {
		if (this.currentStep.isFirst) {
			return;
		}
		const stepNum = this.currentStep.num - 1;
		const step = this.steps.find(i => i.num === stepNum);
		this.changeCurrentStep(step);
	}
	goNext() {
		// Last step: add cards
		if (this.currentStep.isLast) {
			this.apply();
			return;
		}
		if (this.checkGoNextDisabled(this.currentStep.prop)) {
			return;
		}
		const stepNum = this.currentStep.num + 1;
		const step = this.steps.find(i => i.num === stepNum);
		this.changeCurrentStep(step);
	}
	private removeAll(restore?: boolean) {
		this.stopPick();
		this.mapService.removeAddressRelocationInteractions();
		// this.endModify(restore);
		if (this.map.addedLayers[this.mapLayerService.addressRelocateHintLayerName]) {
			this.map.removeLayer(this.mapLayerService.addressRelocateHintLayerName);
		}
		if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
			this.map.removeLayer(this.mapLayerService.addressLineLayerName);
		}
	}
	private clearHintLayer() {
		this.mapService.clearLayer(this.mapLayerService.addressRelocateHintLayerName)
		console.log('clear hint layer');
	}
	private stopPick(feat?) {
		this.mapService.endPickOnMap(this.map)
	}


	onChangeFbFilter() {
		
	}
	checkGoNextDisabled(stepProp: AddressStepProp) {
		switch (stepProp) {
			case 'fbFilter':
				return !this.fbFilter;
			case 'pickAddresses':
				return !this.selectedAddresses.length;
			case 'pickLine':
				return !this.selectedLine;
		}
	}
	private changeCurrentStep(step: EditWizardStep) {		
		switch (step.prop) {
			case 'fbFilter':
				if (this.currentStep && this.currentStep.prop === 'pickLine') {
					this.clearHintLayer();
					this.stopPick();
				}
				break;
			case 'pickAddresses':
				this.selectedLine = null;
				this.startPickAddress();
				break;
			case 'pickLine':
				this.startPickLine();
		}
		this.currentStep = step;
	}
	private startPickAddress() {
		this.mapService.isPickingFeat = true;
		this.mapService.addAddressRelocationInteractions((e) => {
			this.selectedAddresses = (<Feature<Point>[]>this.mapService.addressRelocateSelectInteraction.getFeatures().getArray());
		}, (feats: Feature<Point>[]) => {
			this.mapService.addressRelocateSelectInteraction.getFeatures().clear();
			const filteredFeats = this.fbFilter.key === null ? feats : feats.filter(f => {
				const fbInfo: AddressFishboneInfo = f.getProperties()[this.attrIndexService.addrFishboneCol];
				if (fbInfo) {
					const fbInfoByModel = this.modelKey === 'L' ? fbInfo.legacy : fbInfo.nena;
					if (fbInfoByModel && (fbInfoByModel.cd === 'FS7' || fbInfoByModel.cd === 'FS7L')) {
						return true;
					}
				}
			});
			filteredFeats.forEach(f => {
				this.mapService.addressRelocateSelectInteraction.getFeatures().push(f);
			});
			this.selectedAddresses = (<Feature<Point>[]>this.mapService.addressRelocateSelectInteraction.getFeatures().getArray());
		}, (e) => {
			if (e.type === 'singleclick') {
				if (this.currentStep && this.currentStep.prop === 'pickAddresses') {
					return true;
				}
			}
		});
	}
	private startPickLine() {
		this.mapService.startPickOnMap(this.map, [this.mapLayerService.bgReferenceLayerName], async (result) => {
			const line = result.feat;
			this.selectedLine = line;
			if (line) {
				const lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
				lineLayer.getSource().clear();
				lineLayer.getSource().addFeature(line);
				//
				const roadId = (<string>this.selectedLine.getId());
				if (!this.linePropsById[roadId]) {
					const filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.eq.name, roadId);
					const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
					const rsp = await this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo);
					if (rsp.data && rsp.data[0]) {
						this.linePropsById[roadId] = rsp.data[0];
					} else {
						this.linePropsById[roadId] = {};
						this.toastr.warning('Can not find centerline attributes.');
					}
				}
				// // Check road's address ranges
				// const roadAttrs = this.linePropsById[roadId];

				// setTimeout(() => {
				// 	this.mapService.endPickOnMap(this.map);
				// 	this.stepNum++;

				// }, 500); // setTimeout so that selectFromMapCondition can kick in
			} else {
				this.toastr.info('Centerline not found.')
			}
		});	
	}

	async ngOnInit() {
		this.fbFilter = this.fbFilters[0];
		this.onChangeFbFilter();

		this.changeCurrentStep(this.steps[0]);

		this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === this.attrIndexService.cateCodeCenterline).id;
		const centerlineLayerCate = this.appinfoService.layerTypeList.find(i => i.code === this.attrIndexService.cateCodeCenterline);
		this.centerlineCate = centerlineLayerCate;
		if (!centerlineLayerCate.standardCols) {
			const stdSchema = await this.fieldMappingService.getStandardSchema(centerlineLayerCate.id);
			centerlineLayerCate.standardCols = stdSchema;
		}
		this.addrCate = this.appinfoService.layerTypeList.find(i => i.code === this.attrIndexService.cateCodeAddress);
		if (!this.addrCate.standardCols) {
			const stdSchema = await this.fieldMappingService.getStandardSchema(this.addrCate.id);
			this.addrCate.standardCols = stdSchema;
		}

		this.modelSub = this.mainDataService.modelBS.subscribe(async data => {
			this.modelKey = data;
		});
	}
	ngAfterViewInit(): void {
		this.mapSub = this.mapService.mapBS.subscribe(data => {
			this.map = data;
			if (!this.map.addedLayers[this.mapLayerService.addressRelocateHintLayerName]) {
				this.mapLayerService.addAddressRelocateLineLayer(this.map);
			}
			if (!this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
				this.mapLayerService.addAddressLineLayer(this.map);
			}
		});
	}
	ngOnDestroy(): void {
		this.mapSub.unsubscribe();
		this.modelSub.unsubscribe();
		// this.removeAll();
	}

}

// apply() {
// 	// TODO: multi story
// 		// this.changedAddresses.forEach(id => {
// 		// 	let attrs = this.mainDataService.getDataAttrs(id);
// 		// 	if (!attrs) {
// 		// 		console.log('need debug: cannot find attrs.');
// 		// 		return;
// 		// 	}
// 		// 	const
// 		// 	this.mainDataService.addRecToCard(id);
// 		// })
// 	if (this.selectedAddr) {
// 		const id = this.selectedAddr.getId();
// 		let attrs = this.mainDataService.getDataAttrs(id);
// 		if (!attrs) {
// 			console.log('need debug: cannot find attrs.');
// 			return;
// 		}
// 		// Update stored geom
// 		const wktFormat = new WKT();
// 		const geomUpdate = wktFormat.writeGeometry(this.selectedAddr.getGeometry());
// 		this.mainDataService.setDataAttrs(id, this.attrIndexService.geomColManual, geomUpdate);
// 		// Update addr number
// 		if (!this.isKeepAddressNum) {
// 			let addrNumLabel = this.selectedAddr.getProperties()[this.attrIndexService.addrRelocateNumCol];
// 			if (addrNumLabel) {
// 				const addrNum = Number(addrNumLabel);
// 				this.mainDataService.setDataAttrs(id, this.attrIndexService.addrAddNumCol, addrNum);
// 			}
// 		}
// 		// Update info related to the associated road
// 		let props = {};
// 		if (this.relocateMode === 'diffStreet' && this.selectedLines && this.selectedLines[0]) {
// 			const line = this.selectedLines[0];
// 			const lineAttrs = this.linePropsById[line.getId()];
// 			const info = this.mapService.getPointSideToLine(line.getGeometry(), this.selectedAddr.getGeometry().getCoordinates());
// 			props = this.editFeatureService.carryOverCenterlineAttrsToAddress(lineAttrs, info.side, this.addrCate, this.centerlineCate, this.selectedAddr);
// 		} else if (this.relocateMode === 'sameStreet') {
// 			// Donnot need to update attrs for sameStreet mode
// 		}
// 		Object.keys(props).forEach(key => this.mainDataService.setDataAttrs(id, key, props[key]));
// 		this.mainDataService.addRecToCard(id);
// 	}
// 	this.removeAll();
// 	this.activityService.changeTabSubject.next({
// 		tabKey: 'data'
// 	});
// 	this.floatPopupService.closePopup(WizardAddressRelocationComponent);
// }


	// async onChangeRelocateMode() {
	// 	await this.updateGeocodeLocationOnLine();

	// 	this.clearHintLayer();
	// 	this.stopPick();
	// 	this.endModify(true);

	// 	const pickAddressStep = this.steps.find(s => s.prop === 'pickAddresses');
	// 	if (this.relocateMode === 'sameStreet') {
	// 		pickAddressStep.label = 'Pick and move an address'
	// 	} else {
	// 		pickAddressStep.label = 'Pick an address and move it close to the target street'
	// 	}
	// 	// if (this.currentStep.prop !== 'pickAddresses') {
	// 		this.changeCurrentStep(pickAddressStep);
	// 	// }
	// }
	// async onToggleIsKeepAddressNum() {
	// 	if (this.selectedAddr) {
	// 		const hintLayer = this.map.addedLayers[this.mapLayerService.addressRelocateHintLayerName];
	// 		await this.updateLabelByMode(hintLayer, this.selectedAddr);
	// 	}
	// }

	// private changeCurrentStep_(step: EditWizardStep) {		
	// 	switch (step.prop) {
	// 		case 'selectMode':
	// 			if (this.currentStep && this.currentStep.prop === 'pickAddresses') {
	// 				this.clearHintLayer();
	// 				this.stopPick();
	// 				this.endModify(true);
	// 			}
	// 			break;
	// 		case 'pickAddresses':
	// 			this.selectedLines = null;
	// 			this.startPickAddress();
	// 			break;
	// 	}
	// 	this.currentStep = step;
	// }

	// private async updateGeocodeLocationOnLine() {
	// 	this.originalAddrNumGeocode = null;
	// 	if (!this.selectedAddr) {
	// 		return;
	// 	}
	// 	const addrAttrs = this.mainDataService.getDataAttrs(this.selectedAddr.getId());
	// 	let addrNum = addrAttrs ? addrAttrs[this.attrIndexService.addrAddNumCol] : null;
	// 	if (!addrNum && addrNum !== 0) {
	// 		return;
	// 	}
	// 	addrNum = Number(addrNum);
	// 	let line: Feature<LineString>, rangeLeft: number[], rangeRight: number[]
	// 	if (this.relocateMode === 'sameStreet') { // sameStreet
	// 		if (this.selectedAddrRcl && this.selectedAddrRcl.length) {
	// 			const roadId = this.selectedAddrRcl[0].rclGlobalId;
	// 			line = await this.getRoadFeatById(roadId);
	// 		}
	// 	} else { // diffStreat
	// 		if (this.selectedLines && this.selectedLines.length) {
	// 			line = this.selectedLines[0];
	// 		}
	// 	}
	// 	if (!line) {
	// 		return;
	// 	}
	// 	const lineGeom = line.getGeometry();
	// 	const roadAttrs = await this.getRoadAttrsById(line.getId());
	// 	rangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
	// 	rangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
	// 	if ((rangeLeft || rangeRight) && lineGeom) {
	// 		const leftPercent = rangeLeft ? (addrNum - rangeLeft[0]) / (rangeLeft[1] - rangeLeft[0]) : null;
	// 		const rightPercent = rangeRight ? (addrNum - rangeRight[0]) / (rangeRight[1] - rangeRight[0]) : null;
	// 		const coords = lineGeom.getCoordinates();
	// 		const getGeocodeCoord = (percent: number) => {
	// 			if (percent === null) {
	// 				return null;
	// 			}
	// 			if (percent <= 0) {
	// 				return coords[0];
	// 			} else if (percent >= 1) {
	// 				return coords[coords.length - 1];
	// 			} else {
	// 				const result = this.mapSharedService.getSegByGeomPercent(lineGeom, percent);
	// 				if (result.coords) {
	// 					return result.coords[result.coords.length - 1];
	// 				}
	// 			}
	// 		}
	// 		this.originalAddrNumGeocode = {
	// 			left: getGeocodeCoord(leftPercent),
	// 			right: getGeocodeCoord(rightPercent)
	// 		}
	// 	}
	// }

	// private startPickAddress_() {
	// 	this.mapService.startPickOnMap(this.map, [this.mapLayerService.dataLayerName], async result => {
	// 		const addrFeat = result.feat;
	// 		this.selectedAddr = addrFeat;
	// 		this.selectedAddrRcl = null;
	// 		this.selectedLines = null;
	// 		this.originalAddrNumGeocode = null;
	// 		if (addrFeat) {
	// 			const attrs = this.mainDataService.getDataAttrs(addrFeat.getId());
	// 			const gadId = attrs ? attrs[this.attrIndexService.addrIdCol] : null;
	// 			if (!gadId) {
	// 				this.toastr.info('Cannot find gadId');
	// 				this.stopPick();
	// 				return;
	// 			}
	// 			const spinnerId = this.commonService.getRandomId();
	// 			this.commonService.setLoadingSpinner(true, spinnerId);
	// 			try {
	// 				this.selectedAddrRcl = await this.layerService.getRclBySsap(gadId);
	// 				const hintLayer = this.map.addedLayers[this.mapLayerService.addressRelocateHintLayerName];
	// 				await this.updateGeocodeLocationOnLine(); // update geocode AFTER selectedAddrRcl is updated
	// 				if (this.relocateMode === 'sameStreet' && this.selectedAddrRcl) {
	// 					await this.updateLabelByMode(hintLayer, addrFeat);
	// 				}
	// 			} catch (err) {
	// 				console.log(err);
	// 			}
	// 			this.commonService.setLoadingSpinner(false, spinnerId);

	// 			this.stopPick(addrFeat);
				
	// 			// Force show calculated label
	// 			const featProps = addrFeat.getProperties();
	// 			const props = {};
	// 			props[this.attrIndexService.forceShowLabelKey] = true;
	// 			props[this.attrIndexService.addrRelocateNumCol] = featProps[this.attrIndexService.addrAddNumCol];
	// 			props[this.attrIndexService.addrNumPrefixCol] = featProps[this.attrIndexService.addrNumPrefixCol];
	// 			props[this.attrIndexService.addrNumSuffixCol] = featProps[this.attrIndexService.addrNumSuffixCol];
	// 			addrFeat.setProperties(props);
	// 			//
	// 			this.mapService.moveFeaturesToModifyLayer([addrFeat]);
	// 			if (this.relocateMode === 'diffStreet') {
	// 				this.mapService.addDataModify(async e => {
	// 					this.addPointerdragPickStreet();
	// 				}, e => {
	// 					this.removePointerdrag();
	// 					const featId = addrFeat.getId();
	// 					if (this.changedAddresses.indexOf(featId) === -1) {
	// 						this.changedAddresses.push(featId);
	// 					}					
	// 				});
	// 			} else if (this.relocateMode === 'sameStreet') {
	// 				this.mapService.addDataModify(async e => {
	// 					await this.addPointerdragMoveAddress(addrFeat);
	// 				}, e => {
	// 					this.removePointerdrag();
	// 					const featId = addrFeat.getId();
	// 					if (this.changedAddresses.indexOf(featId) === -1) {
	// 						this.changedAddresses.push(featId);
	// 					}
	// 					// const sameLocKey = feat.getProperties()[this.attrIndexService.sameLocationKey];
	// 					// if (sameLocKey) {
	// 					// 	this.mapService.dataSelectInteraction.getFeatures().forEach(f => {
	// 					// 		if (f.getId() !== featId && f.getProperties()[this.attrIndexService.sameLocationKey] === sameLocKey) {
	// 					// 			(<Point>f.getGeometry()).setCoordinates(feat.getGeometry().getCoordinates());
	// 					// 			this.updateFeatStoredGeom(f, true);
	// 					// 		}
	// 					// 	})
	// 					// }
	// 					// const featsOnDataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatures();
	// 					// const featsOnModifyLayer = this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName].getSource().getFeatures();
	// 					// this.updateSameLocationPoint(featsOnDataLayer.concat(featsOnModifyLayer));
	// 				});
	// 			}
	// 		} else {
	// 			this.toastr.info('Please pick an address to move');
	// 		}
	// 	}, true)
	// }

		// private addPointerdragPickStreet() {
		// 	this.onEditPointerdrag = (e) => {
		// 		if (this.pointerdragPickStreetTimeout) {
		// 			clearTimeout(this.pointerdragPickStreetTimeout);
		// 			this.pointerdragPickStreetTimeout = null;
		// 		}
		// 		const routeLayer = this.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		// 		const endPickStreet = async () => {
		// 			await this.updateGeocodeLocationOnLine();

		// 			this.removePointerdrag();
		// 			await this.addPointerdragMoveAddress(this.selectedAddr);
		// 			clearTimeout(this.pointerdragPickStreetTimeout);
		// 		}
		// 		this.pointerdragPickStreetTimeout = setTimeout(() => {
		// 			if (!this.selectedLines) {
		// 				const pixel = e.pixel;
		// 				this.map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
		// 					if (layer === routeLayer) {
		// 						this.selectedLines = [(<Feature<LineString>>feat)];
		// 						this.mapLayerService.setFeatureFlashStyle(feat);
		// 						endPickStreet();
		// 					}
		// 				}, {
		// 					// hitTolerance
		// 				})
		// 			} else {
		// 				endPickStreet();
		// 			}
		// 		}, 50);
		// 	}
		// 	this.map.olMap.on('pointerdrag', this.onEditPointerdrag);
		// }
		// private async addPointerdragMoveAddress(addrFeat) {
		// 	this.clearHintLayer();
		// 	const hintLayer = this.map.addedLayers[this.mapLayerService.addressRelocateHintLayerName];

		// 	this.onEditPointerdrag = (e) => {
		// 		console.log('pointer draggggg')
		// 		if (this.pointerdragTimeout) {
		// 			clearTimeout(this.pointerdragTimeout);
		// 			this.pointerdragTimeout = null;
		// 		}
		// 		this.pointerdragTimeout = setTimeout(async () => {
		// 			await this.updateLabelByMode(hintLayer, addrFeat);
		// 		}, 100);
		// 	}
		// 	this.map.olMap.on('pointerdrag', this.onEditPointerdrag);
		// }
		// private removePointerdrag() {
		// 	if (this.onEditPointerdrag) {
		// 		this.map.olMap.un('pointerdrag', this.onEditPointerdrag);
		// 		this.onEditPointerdrag = null;
		// 	}
		// }
	// private async getRoadAttrsById(lineGlobalId) {
	// 	if (!this.linePropsById[lineGlobalId]) {
	// 		const filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.eq.name, lineGlobalId);
	// 		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
	// 		const rsp = await this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo);
	// 		if (rsp.data && rsp.data[0]) {
	// 			this.linePropsById[lineGlobalId] = rsp.data[0];
	// 		} else {
	// 			this.linePropsById[lineGlobalId] = {};
	// 			this.toastr.warning('Can not find centerline attributes.');
	// 		}
	// 	}
	// 	return this.linePropsById[lineGlobalId];
	// }
	// private async getRoadFeatById(lineGlobalId) {
	// 	let lineFeat = this.mainDataService.wholeRefData.feats ? (<Feature<LineString>>this.mainDataService.wholeRefData.feats.find(f => f.getId() === lineGlobalId)) : null;

	// 	if (!lineFeat) {
	// 		const roadAttrs = await this.getRoadAttrsById(lineGlobalId);
	// 		let wkt = roadAttrs[this.attrIndexService.geomColManual];
	// 		if (!wkt) {
	// 			const wktRsp = await this.layerService.getLayerGeometry(this.centerlineLayerId, lineGlobalId);
	// 			wkt = wktRsp.data[0][this.attrIndexService.geomCol];
	// 			roadAttrs[this.attrIndexService.geomColManual] = wkt;
	// 		}
	// 		if (!wkt) {
	// 			return;
	// 		}
	// 		lineFeat = (<Feature<LineString>>this.cMapService.createFeatureByWkt(wkt));
	// 	}
	// 	return lineFeat;
	// }
	// private async updateLabelByMode(hintLayer, addrFeat) {
	// 	if (this.relocateMode === 'diffStreet') {
	// 		if (this.selectedLines && this.selectedLines[0]) {
	// 			const lineFeat = this.selectedLines[0];
	// 			await this.setLabel(hintLayer, lineFeat.getId(), addrFeat, lineFeat);
	// 		}
	// 	} else {
	// 		if (this.selectedAddrRcl) {
	// 			for (let i = 0; i < this.selectedAddrRcl.length; i++) {
	// 				const lineGlobalId = this.selectedAddrRcl[i].rclGlobalId;
	// 				await this.setLabel(hintLayer, lineGlobalId, addrFeat);
	// 			}
	// 		}
	// 	}
	// }
	// private setLabel = async (layer, lineGlobalId, addrFeat, lineFeat?: Feature<LineString>) => {
	// 	layer.getSource().clear();

	// 	const roadAttrs = await this.getRoadAttrsById(lineGlobalId);
	// 	if (!lineFeat) {
	// 		lineFeat = await this.getRoadFeatById(lineGlobalId);
	// 	}
	// 	const addrCoord: number[] = addrFeat.getGeometry().getCoordinates();
	// 	const info = this.mapService.getPointSideToLine(lineFeat.getGeometry(), addrCoord);

	// 	let pointOnLine: number[];
	// 	if (this.isKeepAddressNum && this.originalAddrNumGeocode) {
	// 		if (info.side === 'left') {
	// 			pointOnLine = this.originalAddrNumGeocode.left;
	// 		} else {
	// 			pointOnLine = this.originalAddrNumGeocode.right;
	// 		}
	// 		const addrAttrs = this.mainDataService.getDataAttrs(addrFeat.getId());
	// 		const props = addrFeat.getProperties();
	// 		if (addrAttrs && addrAttrs[this.attrIndexService.addrAddNumCol] !== props[this.attrIndexService.addrRelocateNumCol]) {
	// 			props[this.attrIndexService.addrRelocateNumCol] = addrAttrs[this.attrIndexService.addrAddNumCol];
	// 				addrFeat.setProperties(props);
	// 			}
	// 	} else {
	// 		pointOnLine = lineFeat.getGeometry().getClosestPoint(addrCoord);
	// 		// Update label
	// 		let addrRange: number[];
	// 		let parity: ParityValue;
	// 		const roadAddrRangeLeft = [roadAttrs[this.attrIndexService.fromAddrLeftColName], roadAttrs[this.attrIndexService.toAddrLeftColName]];
	// 		const roadAddrRangeRight = [roadAttrs[this.attrIndexService.fromAddrRightColName], roadAttrs[this.attrIndexService.toAddrRightColName]];
	// 		if (info.side === 'left') {
	// 			addrRange = roadAddrRangeLeft;
	// 			parity = roadAttrs[this.attrIndexService.parityLeftColName];
	// 		} else {
	// 			addrRange = roadAddrRangeRight;
	// 			parity = roadAttrs[this.attrIndexService.parityRightColName];
	// 		}
	// 		const addrNum = this.editFeatureService.getAddressNumInterpolate(pointOnLine, lineFeat, addrRange, parity);
	// 		const props = {};
	// 		props[this.attrIndexService.addrRelocateNumCol] = addrNum;
	// 		this.selectedAddr.setProperties(props);
	// 	}
	// 	if (pointOnLine) {
	// 		const dashFeat = new Feature({
	// 			geometry: new LineString([pointOnLine, addrCoord])
	// 		});
	// 		const pointFeat = new Feature({
	// 			geometry: new Point(pointOnLine)
	// 		});
	// 		layer.getSource().addFeature(dashFeat);
	// 		layer.getSource().addFeature(pointFeat);
	// 	}
	// }
	// private endModify(restore?: boolean) {
	// 	this.mapService.removeDataModify();
	// 	if (restore) {
	// 		const modifyLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
	// 		const feats = modifyLayer.getSource().getFeatures();
	// 		const ids = feats.map(f => f.getId());
	// 		this.mapService.resetFeaturesGeom(ids, this.mapLayerService.dataModifyLayerName);
	// 	}
	// 	this.mapService.moveFeaturesBackFromModifyLayer();
	// }
